import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStatusWarning = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			rx: 8,
			fill: "#FFCF23"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7.11133,
			y: 4.14819,
			width: 1.77778,
			height: 4.74074,
			rx: .888889,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7.11133,
			y: 10.6667,
			width: 1.77778,
			height: 1.77778,
			rx: .888889,
			fill: "white"
		})
	]
});
export default SvgStatusWarning;
